// frontend/src/types/systemHealth.ts

export interface K8sClusterInfo {
  id: string;
  name: string;
  version?: string;
}

export interface NamespaceInfo {
  cluster_id: string;
  name: string;
}

/** Maps to models.SystemHealthStatus enum in swagger */
export type SystemHealthStatus = 'healthy' | 'degraded' | 'down' | 'no_data' | 'undeployed';

export interface SystemHealthModule {
  module_id: string;
  module_code: string;
  module_name: string;
  clusters: K8sClusterInfo[];
  namespaces: NamespaceInfo[];
  status: SystemHealthStatus | string;
  total_pods: number;
  running_pods: number;
  pending_pods: number;
  failed_pods: number;
  health_percent: number;
  last_sync_time: string | null;
}

export interface SystemHealthData {
  system_id: string;
  system_code: string;
  system_name: string;
  system_type: 'system' | 'service' | 'module';
  clusters: K8sClusterInfo[];
  namespaces: NamespaceInfo[];
  status: SystemHealthStatus | string;
  total_pods: number;
  running_pods: number;
  // Note: pending_pods is only present at module level in the swagger model (ModuleK8sMapping).
  // At system level it may be absent — treat as optional, default to 0 in rendering.
  pending_pods?: number;
  failed_pods: number;
  health_percent: number;
  last_sync_time: string | null;
  modules?: SystemHealthModule[];
}

export type HealthLevel = 'excellent' | 'good' | 'warning' | 'critical' | 'unknown';

export function getHealthLevel(healthPercent: number): HealthLevel {
  if (healthPercent >= 100) return 'excellent';
  if (healthPercent >= 80) return 'good';
  if (healthPercent >= 50) return 'warning';
  if (healthPercent > 0) return 'critical';
  return 'unknown';
}

export function getHealthColor(healthPercent: number): string {
  const level = getHealthLevel(healthPercent);
  switch (level) {
    case 'excellent': return '#52c41a';
    case 'good': return '#fadb14';
    case 'warning': return '#fa8c16';
    case 'critical': return '#f5222d';
    case 'unknown': return '#d9d9d9';
  }
}
